import { client } from '@utils/graphql/setup';
import {
  CriteriaCreator, MutationCreator, QueryCreator, SingleRecordMutationCreator,
} from './base';
import { createAcceptedProperties } from '../helpers';
import * as is from 'is';

const metadataCollectionReturnProperties = createAcceptedProperties(
  'id',
  'key',
  'value',
  'private'
);

const acceptedMetadataCriteria = {
  key: { type: 'string' },
  value: { type: 'string' },
  model: { type: 'enum' },
  model_id: { type: 'string' },
  private: { type: 'boolean' },
};

class MetadataCriteria extends CriteriaCreator {
  constructor(criteria = {}) {
    super(criteria);
  }
  get acceptedCriteria() {
    return acceptedMetadataCriteria;
  }
}

class MetadataMutation extends MutationCreator {
  constructor(queryType = 'create_metadata', criteria = {}) {
    super(queryType, MetadataCriteria);
    this.setCriteria(criteria);
  }
  get acceptedReturnProperties() {
    return metadataCollectionReturnProperties;
  }
}

export class MetadataQuery extends QueryCreator {
  constructor(queryType = 'metadata') {
    super(queryType, MetadataCriteria);
  }
  get acceptedReturnProperties() {
    return metadataCollectionReturnProperties;
  }
}

export function getDeviceMetadataKeys() {
  return {
    execute() {
      return /^dev(?:elop(?:ment)?)?$/i.test(import.meta.env.VITE_ENV)
        ? Promise.resolve().then(() => ({
          data: [{ key: 'mock1', private: false }, { key: 'mock2', private: true }],
        }))
        : client.queryWithoutSubfields(
          'get_device_metadata_keys',
          '{\n  get_device_metadata_keys {\n    key\n    private\n  }\n}'
        );
    },
  };
}

export function getMetadata(criteria) {
  const query = new MetadataQuery();

  if (!is.empty(criteria)) {
    Object.keys(criteria).forEach((key) => {
      query.addCriteria(key, criteria[key]);
    });
  }
  query.addReturnProperties('id', 'key', 'value', 'private');

  return {
    query,
    execute() {
      return client.query(query.name, query.toString());
    },
  };
}

export function createMetadata(input) {
  const mutation = new MetadataMutation('create_metadata', input);
  mutation.addReturnProperties('id', 'key', 'value', 'private');

  return {
    mutation,
    execute() {
      return client.mutate(mutation.name, mutation.toString());
    },
  };
}

const acceptedMetadataUpdateCriteria = {
  key: { type: 'string' },
  value: { type: 'string' },
  private: { type: 'boolean' },
};

class MetadataUpdateCriteria extends CriteriaCreator {
  constructor(criteria = {}) {
    super(criteria);
  }
  get acceptedCriteria() {
    return acceptedMetadataUpdateCriteria;
  }
}

class SingleMetadataMutation extends SingleRecordMutationCreator {
  constructor(queryType, criteria = {}) {
    super(queryType, MetadataUpdateCriteria);
    this.setCriteria(criteria);
  }
  get acceptedReturnProperties() {
    return metadataCollectionReturnProperties;
  }
}

export function updateMetadata(id, input) {
  const mutation = new SingleMetadataMutation('update_metadata', input);
  mutation.setId(id);
  mutation.addReturnProperties('id', 'key', 'value', 'private');

  return {
    mutation,
    execute() {
      return client.mutate(mutation.name, mutation.toString());
    },
  };
}

export function deleteMetadata(id) {
  const mutation = new SingleMetadataMutation('remove_metadata');
  mutation.setId(id);
  mutation.addReturnProperties('id');

  return {
    mutation,
    execute() {
      return client.mutate(mutation.name, mutation.toString());
    },
  };
}